import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import Loader from '../../components/loader/Loader';
import Chart from '../../components/highcharts/Chart';
import { urls } from '../../services/Server';
import './Stats.css';

export default class Stats extends Component {
  /*
    This component is a wrapper for the different stats charts.
  */

  constructor(props) {
    super(props);
    let statsUrl = urls.userStats;
    if (props.member) {
      statsUrl = `${statsUrl}/${props.member.id}`;
    }

    // Initialize the state with no equities and modal not showing.
    this.state = {
      statsLoaded: false,
      stats: {}
    };
    this.loadStats(statsUrl);
  }

  loadStats = statsUrl =>
    fetch(statsUrl, { credentials: 'include' })
      .then(response => response.json())
      .then(json => {
        this.statsLoaded(json);
      });

  statsLoaded = json => {
    this.setState({
      statsLoaded: true,
      stats: json
    });
  };

  render() {
    const { statsLoaded } = this.state;
    if (statsLoaded && this.state.stats.return.length > 1) {
      return (
        <Row>
          <Chart
            container="return-chart"
            chartKey="return-on-investment"
            data={this.state.stats.return}
            className="box"
          />
          <Chart
            container="value-chart"
            chartKey="invested-and-value"
            data={this.state.stats}
            className="box"
          />
          <Chart
            container="return-percent-chart"
            chartKey="return-percent"
            data={this.state.stats}
            className="box"
          />
        </Row>
      );
    }
    if (statsLoaded) {
      return (
        <div className="row">
          <div className="missing-stats box">
            Porteføljen har ikke eksistert lenge nok til å se statistikk.
            Statistikk må være registrert i minst 2 dager.
          </div>
        </div>
      );
    }
    return (
      <div className="row">
        <div className="loading-home box">
          <Loader />
        </div>
      </div>
    );
  }
}

Stats.propTypes = {
  member: PropTypes.objectOf(PropTypes.any)
};
